var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2.9996C11.5585 3.19114 11.084 3.32014 10.586 3.37829C11.0945 3.08071 11.485 2.60918 11.6685 2.04725C11.193 2.32284 10.666 2.52318 10.105 2.63117C9.6565 2.16354 9.016 1.87134 8.308 1.87134C6.7185 1.87134 5.5505 3.32063 5.9095 4.82515C3.864 4.72497 2.05 3.76725 0.8355 2.3116C0.1905 3.39295 0.501 4.80755 1.597 5.52389C1.194 5.51119 0.814 5.4032 0.4825 5.2229C0.4555 6.33747 1.273 7.38022 2.457 7.61233C2.1105 7.70419 1.731 7.72569 1.345 7.65337C1.658 8.60915 2.567 9.30447 3.645 9.32402C2.61 10.1171 1.306 10.4713 0 10.3208C1.0895 11.0035 2.384 11.4017 3.774 11.4017C8.345 11.4017 10.9275 7.62894 10.7715 4.24513C11.2525 3.90553 11.67 3.48188 12 2.9996Z","fill":"#1A1D31"}));
}

Twitter.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
